import React from "react";

const Footer = () => {
  return (
    <div className="page-footer">
      <div className="row">
        <div className="col-xs-12 col-sm-6">
          <span className="txt-color-white"> Titan Scheduling System</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
